
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M0 85.331h512v341.337H0z"}}),_c('path',{attrs:{"d":"M318.33 255.994c0 15.583-27.906 54.539-62.33 54.539s-62.33-38.957-62.33-54.539c0-34.424 27.906-62.33 62.33-62.33s62.33 27.906 62.33 62.33z","fill":"#d80027"}}),_c('path',{attrs:{"d":"M318.33 255.994c0 34.424-27.906 62.33-62.33 62.33s-62.33-27.906-62.33-62.33","fill":"#0052b4"}}),_c('path',{attrs:{"d":"M322.114 311.096l16.528-16.528 11.018 11.018-16.528 16.528zM294.566 338.63l16.528-16.527 11.018 11.018-16.528 16.528zM355.17 344.132l16.527-16.528 11.018 11.018-16.527 16.528zM327.621 371.689l16.528-16.528 11.018 11.018-16.528 16.528zM338.641 327.614l16.528-16.527 11.018 11.018-16.527 16.527zM311.094 355.16l16.528-16.528 11.018 11.018-16.528 16.527zM355.177 200.896l-44.073-44.073 11.018-11.018 44.073 44.073zM311.099 189.881l-16.528-16.527 11.017-11.018 16.528 16.528zM338.635 217.431l-16.528-16.527 11.017-11.018 16.528 16.528zM344.135 156.825l-16.528-16.528 11.018-11.018 16.528 16.528zM371.694 184.374l-16.528-16.527 11.019-11.019 16.527 16.528zM140.31 327.61l44.073 44.074-11.018 11.018-44.074-44.073zM184.368 338.635l16.527 16.527-11.017 11.018-16.528-16.528zM156.832 311.087l16.528 16.528-11.019 11.018-16.527-16.528zM173.363 294.564l44.073 44.073-11.018 11.019-44.073-44.074zM184.384 140.287l-44.073 44.074-11.018-11.018 44.073-44.074zM200.895 156.823l-44.073 44.074-11.018-11.018 44.073-44.074zM217.424 173.351l-44.074 44.074-11.017-11.017 44.074-44.074z"}})])
          )
        }
      }
    